import { useEffect, useState } from 'react';
import { useAnalyticsEvents } from '@atlaskit/analytics-next/useAnalyticsEvents';
import { ANALYTICS_BRIDGE_CHANNEL } from '@atlassian/analytics-bridge/constants';
import { OPERATIONAL_EVENT_TYPE } from '@atlassian/analytics-web-react';
import { getObjectURLFromMediaURLWithCaching } from '@atlassian/help-center-common-util/media-services';

export const useCachedUrl = function (inputUrl: string | null | undefined) {
	const [cachedBannerUrl, setCachedBannerUrl] = useState<string | null>();
	const [isLoading, setIsLoading] = useState<boolean>(true);
	const { createAnalyticsEvent } = useAnalyticsEvents();

	useEffect(() => {
		if (!!inputUrl && inputUrl.startsWith('blob:')) {
			setCachedBannerUrl(inputUrl);
			setIsLoading(false);
		} else if (!!inputUrl) {
			getObjectURLFromMediaURLWithCaching(inputUrl)
				.then((url) => {
					setCachedBannerUrl(url);
					setIsLoading(false);
				})
				.catch((error: Error) => {
					setIsLoading(false);
					createAnalyticsEvent({
						analyticsType: OPERATIONAL_EVENT_TYPE,
						action: 'failed',
						actionSubject: 'useCachedUrl',
						attributes: {
							errorMessage: error.message,
						},
					}).fire(ANALYTICS_BRIDGE_CHANNEL);
				});
		} else {
			setCachedBannerUrl(null);
			setIsLoading(false);
		}
	}, [createAnalyticsEvent, inputUrl, setCachedBannerUrl]);

	return { cachedBannerUrl, isLoading };
};
